
import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';

import { HbaseLinkedService } from 'app/model/linkedservice/hbase.linkedservice';
import { TabularTypeDataset } from './tabular-type.dataset';
import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: 'HBaseObject',
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.HBase_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.HBase_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: HbaseLinkedService.MODEL // Linked service redefined
        }
    }
})
export class HbaseObjectDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
